import React, { Fragment, useEffect, useState } from 'react';
import { PageBody } from '../../components/SiteWrapper';
import { Badge, Button, Card, Col, Container, Row } from 'react-bootstrap';
import DateBox from '../../components/General/DateBox';
// import { ExamList } from '../../components/Exam';
import { getExamStatusAdmin, getExamStatusPerfoma } from '../../api/ExamsAPI';
import NoDataFound from '../../components/General/NoDataFound';
import AnimatedComponent from '../../components/Animation/AnimatedComponent';
import { getAll } from '../../api/MinistryExams';
import { get, useForm } from 'react-hook-form';
import { FormFieldSelect } from '../../components/Form/FormField';
import moment from 'moment';
import { ExamList } from '../../components/ExamAdmin';

const CenterCoordinateExamsAdmin = () => {
  const [inProgressExams, setInProgressExams] = useState([]);
  const [upcomingExams, setUpcomingExams] = useState([]);
  const [exams, setExams] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [examDays, setExamDays] = useState([]);
  const [selectedExams, setSelectedExams] = useState([]);
  const [centerList, setCenterList] = useState([]);
  const [centerCordinatorList, setCenterCordinatorList] = useState([]);

  const fetchExams = async (selectedExam, selectedExamDay) => {
    const examData = await getExamStatusPerfoma({
      selectedExam: selectedExam,
      selectedExamDay: selectedExamDay,
    });
    setSelectedExams(examData?.data?.exam);
    console.log(
      'examData?.data?.examDays[0]?.examCenters',
      examData?.data.exam.examDays[0]?.examCenters
    );
    setCenterList(examData?.data.exam.examDays[0]?.examCenters);
  };
  const fetchExamsAdmin = async (SelectedCenterCordinator) => {
    setInProgressExams([]);
    console.log('SelectedCenterCordinator', SelectedCenterCordinator);
    console.log('selectedExams', selectedExams.id);
    const examData = await getExamStatusAdmin({
      coordinator_id: SelectedCenterCordinator.value,
      exam_id: selectedExams.id,
    });
    const { completed, inProgress, upcoming } = examData.data;

    // setUpcomingExams(upcoming);
    setInProgressExams([]);
    setInProgressExams(inProgress);
    // setUpcomingExams(completed);
  };
  const [filter, setFilter] = useState({
    _page: 1,
    _limit: 1000,
    q: '',
    _sort: 'id',
    _order: 'desc',
    // status:"1"
  });
  const fetchAllMinistryExams = async () => {
    let exams = await getAll(filter);

    const today = new Date();
    const todayStart = new Date(today.setHours(0, 0, 0, 0)); // Start of today

    exams.data.records = exams.data.records.filter(
      (record) => new Date(record.shift_1_start_time) < todayStart
    );

    setExams(exams.data.records);
  };
  const getExamDaysWithMaxDays = (data) => {
    let maxDaysExam = null;
    let maxDaysCount = 0;

    if (data) {
      data.Exams.forEach((exam) => {
        const examDaysCount = exam.examDays.length;

        if (examDaysCount > maxDaysCount) {
          maxDaysCount = examDaysCount;
          maxDaysExam = exam;
        }
      });
      if (maxDaysExam && maxDaysExam.examDays) {
        // Sort examDays by date in ascending order
        maxDaysExam.examDays.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );
      }

      return maxDaysExam ? maxDaysExam?.examDays : [];
    }
  };

  useEffect(() => {
    fetchAllMinistryExams();
  }, []);
  const defaultFilterValue = {
    exam: '',
  };

  const {
    control,
    formState: { errors: dashboardFilterError },
    watch,
    setValue,
    getValues,
  } = useForm({
    mode: 'onChange',
    defaultValues: defaultFilterValue,
  });
  const selectedExam = watch('exam');
  const selectedExamDay = watch('examDay');
  const selectedexamDayCenter = watch('examDayCenter');
  const SelectedCenterCordinator = watch('CenterCordinator');

  const getCoordinatorsByCenterId = async (centerId) => {
    const examDays = selectedExams?.examDays || [];
    for (const day of examDays) {
      const examCenters = day.examCenters || [];

      for (const center of examCenters) {
        if (center.center.id === centerId) {
          return center.coordinator.map((coordinator) => ({
            id: coordinator.user.id,
            firstName: coordinator.user.first_name,
            lastName: coordinator.user.last_name,
          }));
        }
      }
    }

    return []; // Return empty array if center is not found
  };

  useEffect(() => {
    console.log('Resetting states...');
    setInProgressExams([]);
    setValue('examDay', []);
    setValue('examDayCenter', []);
    setValue('CenterCordinator', []);

    if (selectedExam) {
      const examDays = getExamDaysWithMaxDays(
        exams.find((exam) => exam.id === selectedExam.value)
      );
      setExamDays(examDays);
    }
  }, [selectedExam]);

  useEffect(() => {
    if (selectedExamDay?.label) {
      fetchExams(selectedExam.value, selectedExamDay.value);
    }
  }, [selectedExamDay]);
  const getCenterCordinator = async (centerId) => {
    const coordinators = await getCoordinatorsByCenterId(centerId.value);
    setCenterCordinatorList(coordinators);
  };

  useEffect(() => {
    if (selectedexamDayCenter) {
      getCenterCordinator(selectedexamDayCenter);
    }
  }, [selectedexamDayCenter]);

  useEffect(() => {
    if (SelectedCenterCordinator?.value) {
      fetchExamsAdmin(SelectedCenterCordinator);
    }
  }, [SelectedCenterCordinator]);

  return (
    <Fragment>
      {/* <h2 className='px-3 py-2 bg-heading fs-2 mb-0'>Exams</h2> */}
      <AnimatedComponent as={PageBody} className='mt-0'>
        <AnimatedComponent as={Card} className='mt-0'>
          <Card.Header>
            <Card.Title>
              <h2 className='page-title'>Perfoma Submission</h2>
            </Card.Title>
            <div className='card-actions d-flex'>
              <Row className='d-flex align-items-center '>
                <FormFieldSelect
                  name='exam'
                  control={control}
                  options={exams.map((exam) => ({
                    label: exam.exam_name,
                    value: exam.id,
                  }))}
                  error={dashboardFilterError?.role}
                  size='3'
                  placeholder='Select Exam'
                />
                <FormFieldSelect
                  name='examDay'
                  control={control}
                  options={[
                    // { label: 'All Exam Days', value: null },
                    ...examDays.map((day) => ({
                      label: moment(day.date).format('DD/MM'),
                      value: day.date,
                    })),
                  ]}
                  error={dashboardFilterError?.role}
                  size='3'
                  placeholder='Select Exam Days'
                  disabled={!getValues('exam')}
                />
                <FormFieldSelect
                  name='examDayCenter'
                  control={control}
                  options={[
                    // { label: 'All Exam Days', value: null },
                    ...centerList.map((center) => ({
                      label: `${center.center.center_code} - ${center.center.center_name} `,
                      value: center.center.id,
                    })),
                  ]}
                  error={dashboardFilterError?.role}
                  size='3'
                  placeholder='Select Center'
                  disabled={!getValues('examDay')?.value}
                />

                <FormFieldSelect
                  name='CenterCordinator'
                  control={control}
                  options={[
                    // { label: 'All Exam Days', value: null },
                    ...centerCordinatorList.map((coordinator) => ({
                      label: `${coordinator.firstName} - ${coordinator.lastName} `,
                      value: coordinator.id,
                    })),
                  ]}
                  error={dashboardFilterError?.role}
                  size='3'
                  placeholder='Select Center Coordinator'
                  disabled={!getValues('examDayCenter')?.value}
                />
              </Row>
            </div>
          </Card.Header>
          <Card.Body className='bg-light-rrb rounded-2'>
            <Container>
              {console.log(
                'inProgressExams===========> ++++++++++++++++++++++++++++',
                inProgressExams
              )}
              {/* In Progress Exams */}
              {inProgressExams &&
                upcomingExams &&
                inProgressExams.length === 0 &&
                upcomingExams.length === 0 && (
                  <NoDataFound message='No exams found' />
                )}
              {inProgressExams && inProgressExams.length > 0 && (
                <ExamList
                  centerCordinator={getValues('CenterCordinator')}
                  title=''
                  exams={inProgressExams.map((exam) => ({
                    title: exam.exam_name,
                    subtitle: `${exam.Post.description} (${exam.Post.name})`,
                    headerBg: 'bg-warning-lt',
                    rows: exam.examDays,
                    footer: 'View Report',
                  }))}
                />
              )}
              {/* Upcoming Exams */}
              {/* {upcomingExams && upcomingExams.length > 0 && (
            <ExamList
              title='Upcoming Exams'
              exams={upcomingExams.map((exam) => ({
                title: exam.exam_name,
                subtitle: `${exam.Post.description} (${exam.Post.name})`,
                headerBg: 'bg-purple-lt',
                rows: exam.examDays,
                footer: null,
              }))}
            />
          )} */}
            </Container>
          </Card.Body>
        </AnimatedComponent>
      </AnimatedComponent>
    </Fragment>
  );
};

export default CenterCoordinateExamsAdmin;
